/**
 * Initialize all social apps.
 */
const init = () => {
  window.fbAsyncInit = function() {
    FB.init({
      appId: process.env.VUE_APP_FACEBOOK_APP_ID,
      autoLogAppEvents: true,
      xfbml: true,
      version: "v7.0",
    });
  };
};

module.exports = {
  init,
};
